import { useDispatch } from "react-redux";
import { CONTRACT_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import UpdateDeleteModal from "../../../globalComponents/Modals/UpdateDeleteModal/UpdateDeleteModal";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { downloadContractAction } from "../../../redux/actions/contractActions";
import { FaFileDownload } from "react-icons/fa";
import { useCustomHook } from "../../../globalComponents/GlobalFunctions/globalFunctions";

const toastError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 2000,
    toastClassName: "custom-toast",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

const ContractCard = ({ data, cellNumber }) => {
  const dispatch = useDispatch();
  const { contractTypesList: dataList } = useCustomHook();

  const updateItem = () => {
    dispatch({
      type: CONTRACT_MODAL_ACTION_TYPE.GET_CONTRACT_MODAL,
      payload: {
        data: data,
        openModal: true,
      },
    });
  };

  const downloadFile = () => {
    dispatch(downloadContractAction(data));
  };

  const doubleClick = () => {
    updateItem();
  };

  return (
    <tr className="class-table" onDoubleClick={doubleClick}>
      <td>
        <div className="td-con">
          <div className="table-scroll-text">
            {cellNumber}. {data.name}
          </div>
        </div>
      </td>
      <td>
        <div className="td-con">
          <div className="table-scroll-text">
            {" "}
            {cellNumber}.{" "}
            {dataList.find((item) => item.key === data.contractType)?.name ||
              ""}
          </div>
        </div>
      </td>
      <td>
        <div className="td-con">
          <div className="table-scroll-text">
            {data.isActive ? "Aktiv" : "Deaktiv"}
          </div>
        </div>
      </td>
      <td>
        <div className="td-con">
          <div className="table-scroll-text">
            <Button
              variant="contained"
              onClick={downloadFile}
              sx={{ textTransform: "capitalize" }}
            >
              Müqaviləni Endir <FaFileDownload />
            </Button>
          </div>
        </div>
      </td>
      <td>
        <UpdateDeleteModal
          updateItem={updateItem}
          deleteItem={() => {}}
          data={data}
          state={data}
          openConfirmModal={() => {}}
          openMoreModal={() => {}}
          profil={"contracts"}
          setShowDeleteModal={() => {}}
        />
      </td>
    </tr>
  );
};

export default ContractCard;
